import { CLOSE_REASON_LABEL } from "./monitor.constants";

/** "1.2 s", "340 ms", "2 min 5 s" ("—" when unknown). */
export function durationText(ms) {
  if (ms === null || ms === undefined) return "—";
  if (ms < 1000) return `${ms} ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)} s`;
  return `${Math.floor(ms / 60000)} min ${Math.round((ms % 60000) / 1000)} s`;
}

/** A case's close reason as text; a manual stop keeps the note typed with it. */
export function closeReasonText(reason) {
  if (!reason) return "—";
  const [code, ...note] = reason.split(": ");
  const label = CLOSE_REASON_LABEL[code] ?? code;
  return note.length ? `${label}: ${note.join(": ")}` : label;
}

/** "user 84" / "platform" for a subject key ("U:84" / "-"). */
export const subjectKeyText = (key) => (key === "-" ? "Platform" : String(key ?? "").replace(/^U:/, "User #"));
